import React, { useState } from "react";
import classNames from "classnames";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { HiOutlineLogout } from "react-icons/hi";
import { HEADER_HEIGHT_CLASS } from "constants/theme.constant";
import Logo from "components/template/Logo";
import LanguageSelector from "components/template/LanguageSelector";
import Notification from "components/template/Notification";
import PlatformOnboard from "components/shared/PlatformOnboard";
import { ConfirmDialog } from "components/shared";
import useAuthority from "utils/hooks/useAuthority";
import useAuth from "utils/hooks/useAuth";

const CustomerMobileHeader = () => {
  const { t } = useTranslation();
  const { signOut } = useAuth();
  const [logoutConfirmOpen, setLogoutConfirmOpen] = useState(false);
  const userAuthority = useSelector((state) => state.auth.user?.authority);
  const onboardOpen = useSelector((state) => state.base.common.onboard);
  const onboardReplayKey = useSelector(
    (state) => state.base.common.onboardReplayKey,
  );
  const canSeeOnboard = useAuthority(userAuthority, [
    "Admin",
    "Operator",
    "Manager",
    "Customer",
    "Recycler",
    "Refurbisher",
  ]);

  return (
    <header
      className={classNames(
        "header shadow-sm dark:shadow-none border-b border-gray-100 dark:border-gray-700 bg-white dark:bg-gray-800"
      )}
    >
      <div
        className={classNames(
          "header-wrapper flex items-center justify-between px-4",
          HEADER_HEIGHT_CLASS
        )}
      >
        <div className="flex items-center min-w-0 min-h-[2.25rem] max-w-[55%]">
          <Link
            to="/home"
            className="flex items-center min-w-0 w-full rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-kostebek-500 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-gray-800"
            aria-label={t("nav.home")}
          >
            <Logo
              type="full"
              variant="sidenav"
              className="flex items-center min-w-0 w-full"
              imgClass="h-8 w-auto max-h-9 max-w-full object-contain object-left"
            />
          </Link>
        </div>
        <div className="flex items-center gap-0 shrink-0">
          <LanguageSelector />
          <Notification />
          <button
            type="button"
            className="header-action-item header-action-item-hoverable text-gray-600 dark:text-gray-300"
            aria-label={t("header.user.logoutAria")}
            onClick={() => setLogoutConfirmOpen(true)}
          >
            <HiOutlineLogout className="text-xl" />
          </button>
        </div>
      </div>
      {!onboardOpen && canSeeOnboard && (
        <PlatformOnboard key={onboardReplayKey} />
      )}
      <ConfirmDialog
        isOpen={logoutConfirmOpen}
        type="warning"
        title={t("header.user.logoutConfirmTitle")}
        onClose={() => setLogoutConfirmOpen(false)}
        onCancel={() => setLogoutConfirmOpen(false)}
        onRequestClose={() => setLogoutConfirmOpen(false)}
        onConfirm={() => {
          setLogoutConfirmOpen(false);
          signOut();
        }}
        confirmButtonColor="red-600"
      >
        <p className="text-sm text-gray-600 dark:text-gray-300">
          {t("header.user.logoutConfirmText")}
        </p>
      </ConfirmDialog>
    </header>
  );
};

export default CustomerMobileHeader;
